/**
 * Вибір ключа організації для груп акредитацій за GrowthBook-прапором
 * `accreditationGroupsInternalOrganizationId` (дефолт OFF).
 * OFF -> `organizationItId`, ON -> внутрішній `organizationId`. Тимчасовий: видалити після QA.
 * Потребує `growthBook` з globalMixin.
 */
export default {
  methods: {
    /**
     * Ключ організації у активному просторі id.
     * @param {{ organizationId?: number|null, organizationItId?: number }} organization
     * @returns {number|null|undefined}
     */
    $_accreditationOrganizationKey(organization) {
      return this.growthBook?.accreditationGroupsInternalOrganizationId ? organization?.organizationId : organization?.organizationItId
    },
  },
}
